/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import StringResources from 'nls/StringResources';

import {
	Slider,
	NumberInput,
	Label
} from 'ca-ui-toolkit';

export default class RgbSlider extends Component{

	static propTypes = {
		color: PropTypes.string,
		validateInput: PropTypes.func,
		selectedColorType: PropTypes.string,
		value: PropTypes.int
	}

	constructor(props){
		super(props);
		this.sliderText = null;
	}

	_inputValidation = (value) =>{

		if(this.props.selectedColorType == 'RGB' && value > 255){
			return false;
		}

		if(this.props.selectedColorType == 'HSB'){
			if(this.props.color == 'Hue' && value > 360){
				return false;
			}else if((this.props.color == 'Saturation' || this.props.color == 'Brightness') && value > 100){
				return false;
			}
		}

		return true;
	}

	getInputBoxType(){

		let sliderId = 'id' + (this.props.color.charAt(0).toUpperCase() + this.props.color.slice(1)) + 'Range';
		let textBoxId = 'idText' + this.props.color;
		let max = this.props.selectedColorType == 'RGB' ? 255 : (this.props.color == 'Hue' ? 360 : 100);

		return (
			<tr style={{ paddingTop:'20px', height:'50px' }}>
				<td style={{ width: '38px' }}>
					<Label
						id={textBoxId + 'Label'}
						type='caption'
						hover={true}
						label={StringResources.get('code'.concat(this.props.color))}
						htmlFor={textBoxId}
						style={{ fontSize: '1em' , marginTop: '10px' }}
						title={StringResources.get('color'.concat(this.props.color))}
						alt={StringResources.get('color'.concat(this.props.color))}
					/>
				</td>
				<td style={{ width: '150px' }}>
					<Slider
						id={sliderId}
						showBoundaryLabels
						value={this.props.value}
						onChange={(value) => this.props.validateInput(parseInt(value,10), this.props.color)}
						min={0}
						max={max}
						size='small'
					/>
				</td>
				<td style={{ paddingLeft: '8px' }}>
					<NumberInput
						id={textBoxId}
						value={this.props.value}
						onChange={(value) => this.props.validateInput(parseInt(value,10), this.props.color)}
						style={{ width: '70px' }}
						min={0}
						max={max}
						validation={this._inputValidation}
						tabIndex={0}
					/>
				</td>
			</tr>
		);
	}


	render(){
		let inputBox = this.getInputBoxType();

		return(
			<table>
				<tbody>
					{inputBox}
				</tbody>
			</table>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/dialog/RgbSlider.js